import { render } from "./sub.vue?vue&type=template&id=5dd098f9&scoped=true"
import script from "./sub.vue?vue&type=script&lang=js"
export * from "./sub.vue?vue&type=script&lang=js"

import "./sub.vue?vue&type=style&index=0&id=5dd098f9&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5dd098f9"]])

export default __exports__